// Mock data for WealthOptimizers.com

export const companyInfo = {
  name: "WealthOptimizers",
  tagline: "Building Wealth, Optimizing Futures",
  arn: "ARN-XXXXX",
  email: "Gauravsoni@wealthoptimizers.com",
  email2: "wealthoptimizers7@gmail.com",
  whatsapp: "8788551005",
  whatsappLink: "https://wa.me/918788551005",
  callNumber: "9168327788",
  callLink: "tel:+919168327788",
  serviceArea: "Pan India",
  address: "C402, Aarohi Housing Society, Sus Road, Sus, Pune – 411021",
  disclaimer: "Mutual Fund investments are subject to market risks, read all scheme related documents carefully."
};

export const stats = [
  { label: "Years of Experience", value: "12+" },
  { label: "Pan-India Presence", value: "All India" },
  { label: "AMFI Registered", value: "Compliant" }
];

export const services = [
  {
    id: 1,
    title: "Mutual Fund Advisory",
    description: "Expert guidance in selecting the right mutual funds aligned with your financial goals and risk appetite. Our disciplined approach helps you build wealth systematically through equity, debt, and hybrid funds.",
    icon: "TrendingUp"
  },
  {
    id: 2,
    title: "Life Insurance Solutions",
    description: "Comprehensive life insurance planning to secure your family's financial future. We help you choose the right coverage amount and policy type based on your life stage and protection needs.",
    icon: "Shield"
  },
  {
    id: 3,
    title: "Health Insurance Planning",
    description: "Robust health insurance coverage to protect you from rising medical costs. We analyze your healthcare needs and recommend suitable policies with adequate coverage and benefits.",
    icon: "Heart"
  },
  {
    id: 4,
    title: "Goal-Based Financial Planning",
    description: "Strategic financial planning for life goals like children's education, home purchase, or dream vacation. We create customized investment strategies to help you achieve each milestone.",
    icon: "Target"
  },
  {
    id: 5,
    title: "SIP & Wealth Accumulation",
    description: "Systematic Investment Plans (SIP) for disciplined wealth creation. Harness the power of compounding and rupee cost averaging to build a substantial corpus over time.",
    icon: "PiggyBank"
  },
  {
    id: 6,
    title: "Retirement Planning",
    description: "Comprehensive retirement planning to ensure financial independence in your golden years. We help you build a retirement corpus that maintains your lifestyle and dignity.",
    icon: "Briefcase"
  }
];

export const whyUsPoints = [
  {
    id: 1,
    title: "Process-Driven Approach",
    description: "We follow a structured, disciplined process for every investment decision, ensuring consistency and reliability in our advisory services.",
    icon: "Settings"
  },
  {
    id: 2,
    title: "Long-Term Orientation",
    description: "Our focus is on building sustainable wealth over the long term, not chasing short-term market trends or speculative gains.",
    icon: "TrendingUp"
  },
  {
    id: 3,
    title: "Risk-Aligned Advice",
    description: "We ensure every investment recommendation is aligned with your risk profile, financial goals, and life stage.",
    icon: "ShieldCheck"
  },
  {
    id: 4,
    title: "Compliance-First",
    description: "As an AMFI-registered distributor, we adhere to the highest standards of regulatory compliance and ethical conduct.",
    icon: "CheckCircle"
  },
  {
    id: 5,
    title: "Transparent Communication",
    description: "Clear, honest communication about products, costs, and expected outcomes. No hidden charges or misleading promises.",
    icon: "MessageSquare"
  },
  {
    id: 6,
    title: "Ongoing Support",
    description: "Continuous portfolio monitoring and periodic reviews to ensure your investments stay on track with your goals.",
    icon: "Headphones"
  }
];

export const investmentProcess = [
  {
    step: 1,
    title: "Understanding Your Goals",
    description: "We begin by understanding your financial aspirations, life goals, and current financial situation through detailed discussions."
  },
  {
    step: 2,
    title: "Risk Profiling",
    description: "Comprehensive assessment of your risk tolerance, investment horizon, and financial capacity to take risks."
  },
  {
    step: 3,
    title: "Asset Allocation Strategy",
    description: "Creating an optimal asset allocation strategy that balances risk and return potential based on your profile."
  },
  {
    step: 4,
    title: "Product Selection",
    description: "Selecting the right mutual funds, insurance products, and investment instruments that fit your strategy."
  },
  {
    step: 5,
    title: "Ongoing Review & Support",
    description: "Regular portfolio reviews, rebalancing, and continuous support to keep your investments aligned with your goals."
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Chirag Joshi",
    designation: "IT Professional",
    content: "Working with WealthOptimizers has been a transformative experience. Their disciplined approach to SIP investing helped me build a substantial corpus over the last 5 years. The team's transparency and regular portfolio reviews give me complete confidence in my financial journey.",
    rating: 5
  },
  {
    id: 2,
    name: "Vijaybhaskar Reddy",
    designation: "Business Person",
    content: "As a business owner, I needed expert guidance to manage my personal wealth separately from business finances. WealthOptimizers provided excellent advice on asset allocation and helped me create a robust retirement plan. Their professionalism and knowledge are commendable.",
    rating: 5
  },
  {
    id: 3,
    name: "Sanjay Kumar",
    designation: "Senior Manager",
    content: "The goal-based planning approach really works! WealthOptimizers helped me systematically plan for my children's education and my own retirement simultaneously. Their risk-aligned recommendations and ongoing support have made wealth building a stress-free experience.",
    rating: 5
  }
];

export const teamMembers = [
  {
    id: 1,
    name: "Gaurav Soni",
    designation: "Founder & Principal Advisor",
    description: "AMFI-registered mutual fund distributor with 12 years of experience in wealth management. Worked with ICICI Securities, Axis Mutual Fund, Mirae Asset Mutual Fund, and Groww Mutual Fund. Passionate about helping corporate professionals achieve their financial goals through disciplined investing.",
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400",
    experience: [
      "ICICI Securities",
      "Axis Mutual Fund",
      "Mirae Asset Mutual Fund",
      "Groww Mutual Fund"
    ],
    totalExperience: "12 Years"
  }
];

export const founderStory = {
  title: "Our Journey",
  content: `WealthOptimizers was founded with a simple yet powerful vision: to help corporate professionals build lasting wealth through disciplined, goal-oriented investing.

With over 12 years of experience in the financial services industry, working with leading organizations like ICICI Securities, Axis Mutual Fund, Mirae Asset Mutual Fund, and Groww Mutual Fund, we recognized a critical gap - many hardworking professionals lacked access to unbiased, professional financial advice that truly put their interests first.

We built WealthOptimizers on three core pillars: transparency, discipline, and long-term thinking. We believe that wealth creation is not about chasing the next hot stock or timing the market. It's about consistent investing, proper asset allocation, and staying the course through market cycles.

Today, we serve corporate investors across India with a commitment to ethical advisory and regulatory compliance. But more than numbers, what drives us is the trust our clients place in us and the financial security we help them achieve.

Our approach is simple - understand your goals, align investments with your risk profile, and provide ongoing support to keep you on track. We're not just advisors; we're your partners in building a financially secure future.`
};

export const philosophy = {
  title: "Our Investment Philosophy",
  points: [
    "Long-term wealth creation over short-term speculation",
    "Disciplined, systematic investing through SIPs",
    "Risk-aligned portfolio construction",
    "Diversification across asset classes",
    "Regular portfolio reviews and rebalancing",
    "Transparent, investor-first approach",
    "Compliance with all regulatory requirements"
  ]
};
